import Swiper from 'swiper'
import { Navigation, Thumbs } from 'swiper/modules'

export class ProductGallery {
  constructor() {
    this.init()
  }

  init() {
    const galleryElements = document.querySelectorAll('[data-swiper="main"]')
    
    if (galleryElements.length === 0) return

    galleryElements.forEach(element => {
      this.initGallery(element)
    })
  }

  initGallery(mainElement) {
    const thumbsElement = mainElement.parentElement.querySelector('[data-swiper="thumbs"]')
    
    if (!thumbsElement) return

    // Configuration du slider des miniatures
    const thumbsSwiper = new Swiper(thumbsElement, {
      modules: [Navigation],
      spaceBetween: 12,
      slidesPerView: 1,
      watchSlidesProgress: true,
      breakpoints: {
        480: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    })

    // Configuration du slider principal
    const mainSwiper = new Swiper(mainElement, {
      modules: [Thumbs],
      spaceBetween: 10,
      thumbs: {
        swiper: thumbsSwiper,
      },
    })

    // Synchronisation des sliders
    mainSwiper.thumbs.swiper = thumbsSwiper
  }
}
